var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "notification-bar", class: _vm.type }, [
      _c(
        "div",
        {
          staticClass: "notification-bar__container",
          class: { "teacher-bar": _vm.isTeacherNotification },
        },
        [
          _c(
            "div",
            {
              staticClass: "notification-bar__content",
              class: {
                "notification-bar__content--no-action": !_vm.actions,
                "notification-bar__content--no-type-block": _vm.hideTypeBlock,
              },
            },
            [
              _vm.icon
                ? _c("rt-picture", {
                    staticClass: "notification-bar__icon",
                    attrs: { src: _vm.icon, autosize: false },
                  })
                : !_vm.hideTypeBlock &&
                  (_vm.notificationData.text || _vm.notificationData.icon)
                ? _c(
                    "div",
                    { staticClass: "notification-bar__icon-box" },
                    [
                      _vm.notificationData.icon
                        ? _c("rt-picture", {
                            staticClass: "notification-bar__icon-box-icon",
                            attrs: {
                              src: _vm.notificationData.icon,
                              autosize: false,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.notificationData.text
                        ? _c(
                            "p",
                            { staticClass: "notification-bar__icon-box-text" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.notificationData.text) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.text
                ? _c("p", {
                    staticClass: "notification-bar__content-text",
                    domProps: { textContent: _vm._s(_vm.text) },
                  })
                : _c(
                    "div",
                    { staticClass: "notification-bar__content-html" },
                    [_vm._t("default")],
                    2
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.actions
            ? _c("div", { staticClass: "notification-bar__action" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://readtheory.org/teachers-lounge/important-google-sso-access-changes-for-students",
                    },
                  },
                  [
                    _vm.actionText
                      ? _c(
                          "primary-button",
                          {
                            staticClass: "notification-bar__action-button",
                            on: { click: _vm.handleClickAction },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.actionText) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "notification-bar__action-close",
                    on: { click: _vm.closeNotification },
                  },
                  [
                    _c("rt-picture", {
                      staticClass: "notification-bar__action-icon-close",
                      attrs: {
                        src: "/assets/app/class/icon-closed.svg",
                        autosize: false,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }